<mat-card>
  <h2>
    <span translate="status-check/title"></span>
    <small><strong translate="status-check/session-id"></strong>: &nbsp;{{ clientSessionId }}</small>
  </h2>
  <mat-card-content>
    <div class="table-wrapper" [style.height.px]="maxHeight">
      <table #table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef><span translate="status-check/test/name"></span></th>
          <td mat-cell *matCellDef="let element">
            <span translate="status-check/name/{{ element.name }}"></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef><span translate="status-check/test/status"></span></th>
          <td mat-cell *matCellDef="let element">
            <span [translate]="element.status"></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="error">
          <th mat-header-cell *matHeaderCellDef><span translate="status-check/test/error"></span></th>
          <td mat-cell *matCellDef="let element">
            <span [translate]="element.error"></span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
